<template>
  <div id="ag-grid-demo">
    <vs-popup
      class="holamundo"
      title="New Bill Description"
      :active.sync="popupActivo"
    >
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/3 w-full topPad">
          <span class="popup_lbl inputStyles">Description</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <vs-input
            class="inputx w-full"
            v-validate="'required|max:35'"
            name="Description"
            v-model="form.itemName"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('Description')"
            >{{ errors.first("Description") }}</span
          >
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full topPad">
          <span class="popup_lbl inputStyles">Amount</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <vs-input
            class="inputx w-full"
            v-validate="{ required: true, regex: /^[0-9 .]+$/ }"
            name="Amount"
            v-model="form.price"
          />
          <span class="text-danger text-sm" v-show="errors.has('Amount')">{{
            errors.first("Amount")
          }}</span>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full topPad">
          <span class="popup_lbl inputStyles">Tax</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <select
            v-model="form.taxId"
            name="Tax"
            class="vs-select--input myselect"
            style="height: 36px"
          >
            <option
              class="vs-component"
              v-for="(item, index) in taxs"
              v-bind:key="index"
              :value="item.id"
            >
              {{ item.name }}
            </option>
          </select>
          <!-- <vs-select class="selectExample w-full" name="Tax" v-model="form.taxId">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in taxs" />
                </vs-select> -->
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full topPad">
          <span class="popup_lbl inputStyles">Type</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <select
            v-model="form.typeId"
            class="vs-select--input myselect"
            style="height: 36px"
          >
            <option
              v-for="type in billTypes"
              :key="type.typeId"
              :value="type.typeId"
            >
              {{ type.typeName }}
            </option>
          </select>
        </div>
      </div>

      <div class="vx-row mb-4 popup_btn">
        <vs-button
          color="primary"
          type="border"
          style="margin-right: 5px"
          @click="saveBillMaster()"
          id="button-with-loading"
          class="float-center vs-con-loading__container"
          >Save</vs-button
        >
        <vs-button
          color="primary"
          type="border"
          style="margin-left: 5px"
          @click="clearFields()"
          >Clear</vs-button
        >
      </div>
    </vs-popup>
    <vx-card>
      <div class="vx-row card-header-row">
        <div>
          <vs-button color="success" type="border" @click="openForm">
            New
          </vs-button>
        </div>

        <div>
          <feather-icon
            icon="XIcon"
            class="custom-class"
            style="width: 20px; height: 20px; color: #009696; cursor: pointer"
            title="Close"
            @click="exit"
          />
        </div>
      </div>
      <vue-good-table
        mode="remote"
        :rows="rows"
        :columns="columns"
        :totalRows="totalRecords"
        :pagination-options="{ enabled: true }"
        :sort-options="{ enabled: false }"
        :isLoading.sync="isLoading"
        @on-page-change="onPageChange"
        @on-column-filter="onColumnFilter"
        @on-row-dblclick="getBillDetail"
        styleClass="vgt-table condensed"
      />
    </vx-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      popupActivo: false,
      taxs: [{}],
      form: {
        itemName: "",
        price: "",
        taxId: "",
        itemId: "",
        typeId: "",
      },
      billTypes: [],
      rows: [],
      columns: [
        {
          label: "DESCRIPTION",
          field: "billDescription",
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: "AMOUNT",
          field: "amount",
          type: "number",
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: "TAX",
          field: "taxName",
          filterOptions: {
            enabled: true,
          },
        },
      ],
      totalRecords: 0,
      isLoading: false,

      serverParams: {
        companyId: this.$session.get("companyId"),
        filter: {},
        currentPage: 1,
        limit: 10,
      },
    };
  },

  mounted() {
    this.getTaxItems();
    this.getBillItemTypes();
    this.loadItems();
  },
  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({
        currentPage: params.currentPage,
      });
      this.loadItems();
    },

    onColumnFilter(params) {
      const f = params.columnFilters;

      let filterObj = {};

      if (f.billDescription) {
        filterObj.billDescription = {
          filter: f.billDescription,
          type: "contains",
        };
      }

      if (f.amount) {
        filterObj.amount = {
          filter: f.amount,
          type: "equals",
        };
      }

      if (f.taxName) {
        filterObj.taxName = {
          filter: f.taxName,
          type: "contains",
        };
      }

      this.updateParams({
        filter: filterObj,
      });

      this.loadItems();
    },

    loadItems() {
      this.isLoading = true;

      this.$http
        .post("getBillItemDashBoard", JSON.stringify(this.serverParams), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("Bill data:", response.data);

          this.rows = response.data.data.records;
          this.totalRecords = response.data.data.recordsTotal;
        })
        .catch((error) => {
          console.error(error);
          this.$vs.notify({
            title: "Error",
            text: "Failed to load bill data",
            color: "danger",
            position: "top-center",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    openForm() {
      this.clearFields();
      this.errors.clear();
      this.popupActivo = true;
    },
    getBillItemTypes() {
      console.log("Calling getBillItemTypes"); // check this
      this.$http
        .post(
          "getBillItemTypes",
          {},
          { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
          console.log("Bill Types Response:", response.data);
          this.billTypes = response.data.data;
        });
    },
    exit() {
      this.$router.push("/Master");
    },

    getBillDetail(params) {
      this.clearFields();
      this.errors.clear();

      const row = params.row;

      this.form.itemName = row.billDescription;
      this.form.price = row.amount;
      this.form.taxId = row.taxId;
      this.form.itemId = parseInt(row.itemId);
      this.form.typeId = row.typeId;

      this.popupActivo = true;
    },
    saveBillMaster() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          var request = {
            companyId: this.$session.get("companyId"),
            userId: this.$session.get("userId"),
            billItem: this.form,
          };
          this.buttonLoading();
          this.$http
            .post("savebillitemmaster", JSON.stringify(request), {
              headers: {
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              this.loadItems();
              this.popupActivo = false;
              this.$vs.loading.close("#button-with-loading > .con-vs-loading");
              document.getElementById("button-with-loading").disabled = false;
              this.$vs.notify({
                title: "Successfully Saved",
                color: "success",
                iconPack: "feather",
                icon: "icon-check",
                position: "top-center",
              });
            })
            .catch((error) => {
              this.$vs.notify({
                title: "Error Occured While Saving",
                color: "danger",
                iconPack: "feather",
                icon: "icon-check",
                position: "top-center",
              });
            });
        }
      });
    },
    getTaxItems() {
      this.$http
        .post("v2/gettaxdetails", {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.taxs = response.data.data;
        });
    },
    clearFields() {
      this.form.itemName = "";
      this.form.price = "";
      this.form.taxId = "";
      this.form.itemId = "";
    },
    buttonLoading() {
      document.getElementById("button-with-loading").disabled = true;
      this.$vs.loading({
        background: "primary",
        color: "#fff",
        container: "#button-with-loading",
        scale: 0.45,
      });
    },
  },
  /* onGridReady(params) {
            this.gridApi.showLoadingOverlay();
            window.addEventListener("resize", function () {
                setTimeout(function () {
                    params.api.sizeColumnsToFit();
                }, 500);
            });
            var request = {
                companyId: this.$session.get('companyId'),
                currentPage: this.gridApi.paginationGetCurrentPage() + 1,
                limit: this.gridApi.paginationGetPageSize(),
                filter: this.gridApi.getFilterModel()
            }
            var datasource = {
                getRows: (params) => {
                    this.$http.post(
                            "getBillItemDashBoard",
                            JSON.stringify(request), {
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            })
                        .then(response => {
                            params.successCallback(response.data.data.records, response.data.data.recordsTotal);
                            this.gridApi.hideOverlay();

                        });
                }
            }
            this.gridApi.setDatasource(datasource);
        },*/
};
</script>

<style>
.popup_lbl {
  padding-left: 10%;
}

.popup_btn {
  margin-left: 100px;
  padding-left: 98px;
}
.inputStyles {
  font-size: 11.8px;
  font-weight: 600;
}
.topPad {
  padding-top: 7px;
}
.card-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
}
.vgt-table thead th {
  background: white;
}

.vgt-wrap__footer {
  background: white;
}

table.vgt-table {
  font-size: 12px;
  border: none;
}

.vgt-right-align {
  text-align: left;
}

.vgt-table.condensed tr {
  height: 56px;
}

.vgt-table.condensed td {
  padding-top: 19px;
}

.vgt-input {
  border: none;
}

.vgt-wrap__footer {
  border: none;
}

.footer__row-count__label,
.footer__row-count__select {
  display: none !important;
}
</style>
